export * from './cookieBarDescriptionsEnglish';
export * from './cookieBarDescriptionsPolish';
